// extracted by mini-css-extract-plugin
export default {"list":"styles-module__list--S4VlM","listItem":"styles-module__listItem--hY2Np","text":"styles-module__text--A7tSC","isSelectedText":"styles-module__isSelectedText--ZITNC"};